module.exports = __webpack_public_path__ + "assets/icon-show.489320df.svg";